import * as React from "react";
import "./styles.scss";
import { PlayerCard, PlayerCardDefaultables } from "../../../../services/bedrock";
import { Button, Dropdown, Icon, Menu, Popup, Table } from "semantic-ui-react";
import { PlayerCardSettingsContext } from "../../Contexts";
import { useContext, useState } from "react";
import { getCountMetricsText } from "../../utils";
import { URLS } from "../../../../utils";
import { Link } from "react-router-dom";

interface PlayerCardRowProps {
  playerCard: PlayerCard;
  onEnablePlayerCardAccess: (playerCard: PlayerCard) => void;
}

const PlayerCardRow: React.FC<PlayerCardRowProps> = ({ playerCard, onEnablePlayerCardAccess }) => {
  const [enablingPlayerCardAccess, setEnablingPlayerCardAccess] = useState(true);
  const { PlayerCards, User } = useContext(PlayerCardSettingsContext);

  const isSelected = playerCard.id === PlayerCards.selectedPlayerCard?.id;

  const selectPlayerCard = () => {
    PlayerCards.setSelectedPlayerCard(playerCard);
    PlayerCards.setInEditMode(true);
  };

  const deletePlayerCard = () => {
    const confirmed = confirm("Are you sure you want to delete this Player Card?");
    if (confirmed) PlayerCards.deletePlayerCard(playerCard.id);
  };

  const editPlayerCard = () => {
    PlayerCards.setSelectedPlayerCard(playerCard);
    PlayerCards.setInEditMode(true);
  };

  const previewPlayerCard = () => {
    window.open(`${playerCard.baseUrl}${playerCard.slug}?preview=true`, "_blank");
  };

  const actions: { key: string; content: string; handler: () => void }[] = [
    { key: "preview", content: "Preview", handler: previewPlayerCard },
  ];
  if (User.hasWritePermission) {
    actions.push({ key: "edit", content: "Edit", handler: editPlayerCard });
    actions.push({ key: "delete", content: "Delete", handler: deletePlayerCard });
  }

  const enablePlayerCardAccess = (event: any) => {
    event.stopPropagation();
    onEnablePlayerCardAccess(playerCard);
    setEnablingPlayerCardAccess(false);
    setTimeout(() => setEnablingPlayerCardAccess(true), 500);
  };

  return (
    <Table.Row className={`selectableRow ${isSelected ? "selected" : ""}`} onClick={selectPlayerCard}>
      <Table.Cell>
        {playerCard.player && (
          <div>
            <div>
              <Link
                to={URLS.coach.editPlayer.replace(":playerId", `${playerCard.player.id}`)}
                onClick={e => e.stopPropagation()}
              >
                <b>{playerCard.player.fullName}</b>
              </Link>
              {playerCard.player.allowPlayerAccessToPlayerCardsPermission || (
                <Popup
                  hoverable
                  disabled={!enablingPlayerCardAccess}
                  trigger={<Icon className="warningIcon" name="warning circle" color="red" />}
                >
                  <Popup.Content>
                    <p>
                      Looks like this player doesn't have Player Card access yet. Enable it below to make their card
                      publicly available.
                    </p>
                    <Button primary onClick={enablePlayerCardAccess} content="Enable access" />
                  </Popup.Content>
                </Popup>
              )}
            </div>
            <div className="captionText grayText">
              <b>Regions:</b> {playerCard.player.regionNames?.join(", ")}
            </div>
            <div className="captionText grayText">
              <b>Branches:</b> {playerCard.player.branchNames?.join(", ")}
            </div>
          </div>
        )}
      </Table.Cell>
      <Table.Cell>
        {playerCard.template && (
          <span>
            {playerCard.template.name}
            {playerCard.templateId === PlayerCardDefaultables.default.id && (
              <span className="grayText"> ({PlayerCardDefaultables.default.name})</span>
            )}
          </span>
        )}
        {!playerCard.template && playerCard.templateId === PlayerCardDefaultables.default.id && (
          <span className="grayText">{PlayerCardDefaultables.default.name}</span>
        )}
        {!playerCard.template && playerCard.templateId === PlayerCardDefaultables.unassigned.id && (
          <span className="grayText">{PlayerCardDefaultables.unassigned.name}</span>
        )}
      </Table.Cell>
      <Table.Cell>
        {playerCard.theme && (
          <span>
            {playerCard.theme.name}
            {playerCard.themeId === PlayerCardDefaultables.default.id && (
              <span className="grayText"> ({PlayerCardDefaultables.default.name})</span>
            )}
            {playerCard.theme.playerId && <span className="grayText"> (Player Theme)</span>}
          </span>
        )}
        {!playerCard.theme && playerCard.themeId === PlayerCardDefaultables.default.id && (
          <span className="grayText">{PlayerCardDefaultables.default.name}</span>
        )}
        {!playerCard.theme && playerCard.themeId === PlayerCardDefaultables.unassigned.id && (
          <span className="grayText">{PlayerCardDefaultables.unassigned.name}</span>
        )}
      </Table.Cell>
      <Table.Cell textAlign="center">{getCountMetricsText(playerCard.viewMetricsCount)}</Table.Cell>
      <Table.Cell textAlign="center">{getCountMetricsText(playerCard.clickMetricsCount)}</Table.Cell>
      <Table.Cell>
        <Menu className="actionsMenu">
          <Dropdown icon="ellipsis horizontal">
            <Dropdown.Menu>
              {actions.map(action => (
                <Dropdown.Item key={action.key} content={action.content} onClick={action.handler} />
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Menu>
      </Table.Cell>
    </Table.Row>
  );
};
export default PlayerCardRow;
